import TermExamsView from '../components/TermExamsView';

const TeacherTermExams = () => <TermExamsView role="teacher" />;

export default TeacherTermExams;
